// ROOT
import { API } from '../../../common/api/constants';

//АВТОРИЗАЦИЯ
export const API_AUTHORIZATION = `${API}/authorization/user`; // POST

//Обновление Токена
export const REFRESH_TOKEN = `${API}/authorization/refresh_token`; // POST

//АВТОРИЗАЦИЯ SMS
export const API_AUTHORIZATION_SENDCODE = `${API}/authorization/smscode`; // GET
export const API_AUTHORIZATION_CHECKCODE = `${API}/authorization/login`; // POST

//АВТОРИЗАЦИЯ ПРОФИЛИ
export const API_AUTHORIZATION_GETPROFILES = `${API}/authorization/profiles/user`; // GET
export const API_GET_SEXES = `${API}/authorization/sexes`; // GET
export const API_GET_POSITIONS = `${API}/authorization/representative/positions`; // GET
export const API_GET_CITIZENSHIPS = `${API}/authorization/citizenships`; // GET
export const API_GET_COMPANY_TYPES = `${API}/authorization/company/types`; // GET
export const API_GET_ROLES = `${API}/authorization/roles`; // GET
export const API_GET_SUBJECTS = `${API}/authorization/subjects`; // GET

//СОЗДАНИЕ ПРОФИЛЯ
export const API_POST_PROFILE_CREATE_AND_FILL = `${API}/authorization/profile/create_and_fill`; // POST

//ДЕЙСТВИЯ С ПРОФИЛЕМ
export const API_PROFILE = `${API}/authorization/profile`;

//Мониторинг профиля
export const MONITORING_PROFILE = `${API}/monitoring/profile/`;

//COMPANY
export const API_ADD_COMPANY = `${API}/authorization/company`; // POST

// АВТОРИЗАЦИЯ / РЕГИСТРАЦИЯ / ЛОГИН
export const API_AUTH_SENDCODE = `${API}/auth/code/send`; // POST
export const API_AUTH_CHECKCODE = `${API}/auth/code/check`; // POST
export const API_AUTH_REGISTER = `${API}/auth/user/register`; // POST
export const API_AUTH_LOGIN = `${API}/auth/user/login`; // POST
export const API_AUTH_LOGIN_EMAIL = `${API}/auth/user/login/email`; // POST

export const API_USER = `${API}/authorization/user`;

// DADATA
export const API_DADATA_SUGGEST_GET = `${API}/dadata/suggest/`; // GET
export const API_DADATA_SUGGEST = `${API}/dadata/suggest/`; // POST
export const API_DADATA_SUGGEST_FIO_POST = `${API}/dadata/suggest/fio/`; // POST
export const API_DADATA_SUGGEST_ORG_POST = `${API}/dadata/suggest/org/`; // POST

// UPLOAD FILES
export const API_USER_PHOTO_UPLOAD = `${API}/utility/image/upload/user`;

// TARIFF
export const API_TARIFF_TYPES = `${API}/finance/tariff_types`;
export const API_TARIFF_FEE_PERIODS = `${API}/finance/tariff_fee_periods`;
export const API_TARIFF_PRICES = `${API}/finance/tariff_prices`;

export const API_TARIFF_PRICE = `${API}/finance/tariff_prices/filter`;
